<template>
  <div>
    <section class="section-header-info middle-content">
      <div class="container big-container">
        <div class="row text-center">
          <div class="col-sm-12">
            <h3>Provider Assigned Jobs</h3>
            <div class="table-legend">
              <ul>
                <li><i class="ic-flight-icon"></i>Airport Transfer</li>
                <li><i class="ic-time"></i>Hourly Booking</li>
              </ul>
            </div>
            <div class="data-row --blue25">
              <strong>{{ time }}</strong>
            </div>
            <div class="form-group mt-20">
              <div
                class="btn-group btn-group-toggle mb-25"
                data-toggle="buttons"
              >
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'all' }"
                  @click="changePeriods('all')"
                >
                  All
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'today' }"
                  @click="changePeriods('today')"
                >
                  Today
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'tomorrow' }"
                  @click="changePeriods('tomorrow')"
                >
                  Tomorrow
                </button>
                <button
                  type="button"
                  class="btn btn-default"
                  :class="{ 'btn-active': period === 'next' }"
                  @click="changePeriods('next')"
                >
                  Next Day
                </button>
                <button
                  type="button"
                  class="btn btn-default btn-selectDate"
                  :class="{ 'btn-active': period === 'range' }"
                >
                  <VueCtkDateTimePicker
                    id="jobBrowserDateRange"
                    name="jobBrowserDateRange"
                    v-model="jobBrowserDateRange"
                    color="#025BC5"
                    format="YYYY-MM-DD"
                    formatted="MMM DD"
                    range
                    no-shortcuts
                    label="Select Date"
                    no-header
                    overlay
                    no-button-now
                    button-color="#FFB733"
                    no-clear-button
                    @is-shown="showPicker()"
                    @is-hidden="hidePicker()"
                    @validate="searchRange()"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Reservation Code"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <ul class="nav nav-tabs tabs-inquiry sticky">
              <li class="active">
                <a
                  data-toggle="tab"
                  href="#job-all"
                  @click="changeProgress('all')"
                >
                  <span class="qty-jobs">{{ totalAllJobs }}</span> All
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-open"
                  @click="changeProgress('open')"
                >
                  <span class="qty-jobs">{{ totalJobsOpen }}</span> Open
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-run"
                  @click="changeProgress('run')"
                >
                  <span class="qty-jobs">{{ totalJobsRun }}</span> Run
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-under-review"
                  @click="changeProgress('underreview')"
                >
                  <span class="qty-jobs">{{ totalJobsUnderReview }}</span> Under
                  Review
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-rescue"
                  @click="changeProgress('rescueoperation')"
                >
                  <span class="qty-jobs">{{ totalJobsRescued }}</span> Rescue
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-done"
                  @click="changeProgress('done')"
                >
                  <span class="qty-jobs">{{ totalJobsDone }}</span> Done
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-close"
                  @click="changeProgress('close')"
                >
                  <span class="qty-jobs">{{ totalJobsClose }}</span> Closed
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#job-aborted"
                  @click="changeProgress('abort')"
                >
                  <span class="qty-jobs">{{ totalJobsAborted }}</span> Aborted
                </a>
              </li>
            </ul>
            <div class="tab-content">
              <div id="job-all" class="tab-pane fade in active">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Driver</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th class="text-left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="pos-rel text-center">
                          <span
                            :class="{
                              'sts_job-open': item.progress === 'Open',
                              'sts_job-run': item.progress === 'Run',
                              'sts_job-done': item.progress === 'Done',
                              'sts_job-closed': item.progress === 'Close',
                              'sts_job-aborted': item.progress === 'Abort',
                              'sts_job-rescue_operation':
                                item.progress === 'RescueOperation',
                            }"
                          ></span>
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                          <div class="row-big-menu" v-if="isAllowToRead">
                            <ul>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/provider/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  Details
                                </router-link>
                              </li>
                            </ul>
                          </div>
                          <span
                            v-if="inactiveVehicle(item)"
                            class="sts sts-danger"
                            style="display: block; font-size: small"
                          >
                            Inactive Vehicle
                          </span>
                          <span
                            v-if="inactiveDriver(item)"
                            class="sts sts-danger"
                            style="display: block; font-size: small"
                          >
                            Inactive Driver
                          </span>
                        </td>
                        <td>
                          <strong>{{ item.customerName }}</strong>
                          {{
                            userType === "ProviderUser"
                              ? `+${item.customerPhoneCode} ${item.customerPhoneNumber}`
                              : item.companyName
                          }}
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-under-review" class="tab-pane">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>Code &amp; Provider</th>
                        <th class="text-center">Progress &amp; Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th style="min-width: 130px">Pick-Up</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line" v-if="item.hasProvider">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="text-center">
                          <span
                            :class="{
                              'sts_job-open': item.progress === 'Open',
                              'sts_job-run': item.progress === 'Run',
                              'sts_job-done': item.progress === 'Done',
                              'sts_job-closed': item.progress === 'Close',
                              'sts_job-aborted': item.progress === 'Abort',
                              'sts_job-rescue_operation':
                                item.progress === 'RescueOperation',
                              'sts_job-under-review':
                                item.progress === 'UnderReview',
                            }"
                          ></span>
                          <!-- <span class="last_state">
                            <i class="ic-checklist"></i>
                            <span v-if="item.progress === 'RescueOperation'">
                              {{
                                shortenString(
                                  item.lastState,
                                  "Rescue Operation "
                                )
                              }}
                            </span>
                            <span v-else> {{ getLastState(item) }}</span>
                          </span> -->
                        </td>
                        <td class="pos-rel">
                          <strong>{{ item.customerName }}</strong>
                          {{ item.companyName }}
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-open" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Driver</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th class="text-left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="pos-rel text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                          <div
                            class="row-big-menu"
                            v-if="
                              (isAllowToConfirm &&
                                pickUpDateExpired(item.utcPickUpDate)) ||
                              (isAllowToDecline &&
                                $helper.isNotExpiredDate(item.utcPickUpDate)) ||
                              (isAllowToDispatchVehicle &&
                                $helper.isNotExpiredDate(item.utcPickUpDate)) ||
                              (isAllowToReleaseVehicle &&
                                $helper.isNotExpiredDate(item.utcPickUpDate)) ||
                              (isAllowToDispatchDriver &&
                                $helper.isNotExpiredDate(item.utcPickUpDate)) ||
                              (isAllowToReleaseDriver &&
                                $helper.isNotExpiredDate(item.utcPickUpDate)) ||
                              isAllowToRead
                            "
                          >
                            <ul>
                              <li
                                v-if="
                                  item.isOwnInventory &&
                                  isAllowToConfirm &&
                                  pickUpDateExpired(item.utcPickUpDate)
                                "
                              >
                                <button
                                  class="btn btn-default --green35"
                                  type="button"
                                  @click="openProviderConfirmationDialog(item)"
                                >
                                  <span>Confirm</span>
                                </button>
                              </li>
                              <li
                                v-if="
                                  item.isOwnInventory &&
                                  isAllowToDecline &&
                                  $helper.isNotExpiredDate(
                                    item.utcPickUpDate
                                  ) &&
                                  item.dispatchType.toLowerCase() !==
                                    'byproviderselfdispatch'
                                "
                              >
                                <button
                                  class="btn btn-default sts-danger"
                                  type="button"
                                  @click="openProviderDeclineDialog(item)"
                                >
                                  <span>Decline</span>
                                </button>
                              </li>
                              <li
                                v-if="
                                  item.isOwnInventory &&
                                  (isAllowToDispatchVehicle ||
                                    isAllowToReleaseVehicle ||
                                    isAllowToDispatchDriver) &&
                                  $helper.isNotExpiredDate(item.utcPickUpDate)
                                "
                              >
                                <button
                                  class="btn btn-default"
                                  type="button"
                                  @click="openDispatchModal(item, true, true)"
                                >
                                  <span>Dispatch</span>
                                </button>
                              </li>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/provider/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  Details
                                </router-link>
                              </li>
                            </ul>
                          </div>
                          <span
                            v-if="inactiveVehicle(item)"
                            class="sts sts-danger"
                            style="display: block; font-size: small"
                          >
                            Inactive Vehicle
                          </span>
                          <span
                            v-if="inactiveDriver(item)"
                            class="sts sts-danger"
                            style="display: block; font-size: small"
                          >
                            Inactive Driver
                          </span>
                        </td>
                        <td>
                          <strong>{{ item.customerName }}</strong>
                          {{
                            userType === "ProviderUser"
                              ? `+${item.customerPhoneCode} ${item.customerPhoneNumber}`
                              : item.companyName
                          }}
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-run" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Driver</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th class="text-left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="pos-rel text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                          <div
                            class="row-big-menu"
                            v-if="
                              (isAllowToDispatchVehicle &&
                                pickUpDateExpired(item.utcPickUpDate)) ||
                              (isAllowToReleaseVehicle &&
                                pickUpDateExpired(item.utcPickUpDate)) ||
                              (isAllowToDispatchDriver &&
                                pickUpDateExpired(item.utcPickUpDate)) ||
                              (isAllowToReleaseDriver &&
                                pickUpDateExpired(item.utcPickUpDate)) ||
                              isAllowToRead
                            "
                          >
                            <ul>
                              <li
                                v-if="
                                  item.isOwnInventory &&
                                  (isAllowToDispatchDriver ||
                                    isAllowToReleaseDriver) &&
                                  pickUpDateExpired(item.utcPickUpDate)
                                "
                              >
                                <button
                                  class="btn btn-default --green35"
                                  type="button"
                                  @click="openDispatchModal(item, false, true)"
                                >
                                  <span>Driver</span>
                                </button>
                              </li>
                              <li
                                v-if="
                                  item.isOwnInventory &&
                                  (isAllowToDispatchVehicle ||
                                    isAllowToReleaseVehicle) &&
                                  pickUpDateExpired(item.utcPickUpDate)
                                "
                              >
                                <button
                                  class="btn btn-default --green35"
                                  type="button"
                                  @click="openDispatchModal(item, true, false)"
                                >
                                  <span>Vehicle</span>
                                </button>
                              </li>
                              <li v-if="item.isOwnInventory && canRescue(item)">
                                <button
                                  class="btn btn-default --green35"
                                  type="button"
                                  @click="openRescueDialog(item)"
                                >
                                  <span>Rescue</span>
                                </button>
                              </li>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/provider/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  Details
                                </router-link>
                              </li>
                              <li
                                v-if="
                                  isShowTripLog &&
                                  (userType === 'TenantUser' ||
                                    userType === 'ProviderUser')
                                "
                              >
                                <router-link
                                  :to="`/reservation/provider/trip-log/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-info btn btn-default"
                                >
                                  Logging
                                </router-link>
                              </li>
                            </ul>
                          </div>
                          <span
                            v-if="inactiveVehicle(item)"
                            class="sts sts-danger"
                            style="display: block; font-size: small"
                          >
                            Inactive Vehicle
                          </span>
                          <span
                            v-if="inactiveDriver(item)"
                            class="sts sts-danger"
                            style="display: block; font-size: small"
                          >
                            Inactive Driver
                          </span>
                        </td>
                        <td>
                          <strong>{{ item.customerName }}</strong>
                          {{
                            userType === "ProviderUser"
                              ? `+${item.customerPhoneCode} ${item.customerPhoneNumber}`
                              : item.companyName
                          }}
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-rescue" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Driver</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th class="text-left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="pos-rel text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                          <div
                            class="row-big-menu"
                            v-if="
                              isAllowToDispatchDriver ||
                              isAllowToReleaseDriver ||
                              isAllowToDispatchVehicle ||
                              isAllowToReleaseVehicle ||
                              isAllowToRead
                            "
                          >
                            <ul>
                              <li
                                v-if="
                                  item.isOwnInventory &&
                                  (isAllowToDispatchDriver ||
                                    isAllowToReleaseDriver) &&
                                  !item.hasDriver
                                "
                              >
                                <button
                                  class="btn btn-default --green35"
                                  type="button"
                                  @click="openDispatchModal(item, false, true)"
                                >
                                  <span>Driver</span>
                                </button>
                              </li>
                              <li
                                v-if="
                                  item.isOwnInventory &&
                                  (isAllowToDispatchVehicle ||
                                    isAllowToReleaseVehicle) &&
                                  !item.hasVehicle
                                "
                              >
                                <button
                                  class="btn btn-default --green35"
                                  type="button"
                                  @click="openDispatchModal(item, true, false)"
                                >
                                  <span>Vehicle</span>
                                </button>
                              </li>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/provider/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  Details
                                </router-link>
                              </li>
                            </ul>
                          </div>
                          <span
                            v-if="inactiveVehicle(item)"
                            class="sts sts-danger"
                            style="display: block; font-size: small"
                          >
                            Inactive Vehicle
                          </span>
                          <span
                            v-if="inactiveDriver(item)"
                            class="sts sts-danger"
                            style="display: block; font-size: small"
                          >
                            Inactive Driver
                          </span>
                        </td>
                        <td>
                          <strong>{{ item.customerName }}</strong>
                          {{
                            userType === "ProviderUser"
                              ? `+${item.customerPhoneCode} ${item.customerPhoneNumber}`
                              : item.companyName
                          }}
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-done" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Driver</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Under Paid?</th>
                        <th>Vehicle</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th class="text-left"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="pos-rel text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                          <div
                            class="row-big-menu"
                            v-if="
                              isAllowToReprice ||
                              isAllowToPublish ||
                              isAllowToClose ||
                              isAllowToRead
                            "
                          >
                            <ul>
                              <li
                                v-if="item.isOwnInventory && isAllowToReprice"
                              >
                                <button
                                  v-if="canReprice(item)"
                                  class="btn btn-default --green35"
                                  type="button"
                                  @click="viewReservationReprice(item)"
                                >
                                  <span>Repricing</span>
                                </button>
                              </li>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/provider/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  Details
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.customerName }}</strong>
                          {{
                            userType === "ProviderUser"
                              ? `+${item.customerPhoneCode} ${item.customerPhoneNumber}`
                              : item.companyName
                          }}
                        </td>
                        <td>
                          <strong>{{ item.isUnderPaid ? "Yes" : "No" }}</strong>
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-close" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Driver</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th class="text-left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="pos-rel text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                          <div class="row-big-menu" v-if="isAllowToRead">
                            <ul>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/provider/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  Details
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.customerName }}</strong>
                          {{
                            userType === "ProviderUser"
                              ? `+${item.customerPhoneCode} ${item.customerPhoneNumber}`
                              : item.companyName
                          }}
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="job-aborted" class="tab-pane fade">
                <div class="table-responsive table-manage">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Type</th>
                        <th>Code &amp; Driver</th>
                        <th class="text-center">Status</th>
                        <th>Passenger</th>
                        <th>Vehicle</th>
                        <th style="min-width: 130px">Pick-Up</th>
                        <th class="text-left">Drop-Off</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="detail-row"
                        v-for="item in items"
                        :key="item.reservationId"
                      >
                        <td class="text-center">
                          <strong>
                            <i
                              v-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isPickUpAirport
                              "
                              class="ic-flight-icon"
                            ></i>
                            <i
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                item.isDropOffAirport
                              "
                              class="ic-flight-departure-icon"
                            ></i>
                            <i
                              class="ic-car-alt"
                              v-else-if="
                                isAirportTransfer(item.serviceType) &&
                                !item.isPickUpAirport &&
                                !item.isDropOffAirport
                              "
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="32"
                                height="32"
                                viewBox="0 0 1200 1200"
                              >
                                <path
                                  fill="currentColor"
                                  d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                                />
                              </svg>
                            </i>
                            <i v-else class="ic-time"></i>
                          </strong>
                        </td>
                        <td>
                          <strong>{{ item.code }}</strong>
                          <span class="new-line">
                            {{ item.providerName }}
                          </span>
                          <span class="new-line" v-if="item.hasDriver">
                            ({{ item.driverName }})
                          </span>
                        </td>
                        <td class="pos-rel text-center">
                          <template v-if="item.workflowControl">
                            <span
                              :class="
                                item.workflowControl.indicator === 1
                                  ? 'green-job mt-5'
                                  : item.workflowControl.indicator === 2
                                  ? 'yellow-job mt-5'
                                  : item.workflowControl.indicator === 3
                                  ? 'red-job mt-5'
                                  : 'last_state d-flex justify-center items-center gap-5'
                              "
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{
                                  item.workflowControl.lastStateDescription
                                }}</span
                              >
                            </span>
                          </template>
                          <template v-else>
                            <span
                              class="last_state d-flex justify-center items-center gap-5"
                            >
                              <i class="ic-checklist"></i>
                              <span v-if="item.progress === 'RescueOperation'">
                                {{
                                  shortenString(
                                    item.lastState,
                                    "Rescue Operation "
                                  )
                                }}
                              </span>
                              <span class="no-wrap" v-else>
                                {{ getLastState(item) }}</span
                              >
                            </span>
                          </template>
                          <div class="row-big-menu" v-if="isAllowToRead">
                            <ul>
                              <li v-if="isAllowToRead">
                                <router-link
                                  :to="`/job/provider/${item.reservationId}`"
                                  target="_blank"
                                  class="sts-warning btn btn-default"
                                >
                                  Details
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </td>
                        <td>
                          <strong>{{ item.customerName }}</strong>
                          {{
                            userType === "ProviderUser"
                              ? `+${item.customerPhoneCode} ${item.customerPhoneNumber}`
                              : item.companyName
                          }}
                        </td>
                        <td>
                          <strong>{{ item.className }}</strong>
                          <span v-if="item.hasVehicle">
                            <span class="new-line">
                              {{ item.vehicleFactory }} {{ item.vehicleBrand }}
                            </span>
                            <span class="new-line">
                              ({{ item.vehiclePlateNo }})
                            </span>
                          </span>
                        </td>
                        <td>
                          <span v-if="item.isTodayPickUp">
                            <span class="sts-danger">Today</span>,
                            {{ item.pickUpDate.stringDate }}
                            {{ item.pickUpDate.stringShortMonth }}
                            {{ item.pickUpDate.year }}
                          </span>
                          <span v-else>{{
                            item.pickUpDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.pickUpDate.stringHour }}:{{
                              item.pickUpDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.pickUpDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.pickUpLocation }}</span>
                        </td>
                        <td>
                          <span v-if="item.isTodayDropOff">
                            <span class="sts-danger">Today</span>,
                            {{ item.dropOffDate.stringDate }}
                            {{ item.dropOffDate.stringShortMonth }}
                            {{ item.dropOffDate.year }}
                          </span>
                          <span v-else>{{
                            item.dropOffDate.stringFullDate
                          }}</span>
                          <strong class="time-utc">
                            {{ item.dropOffDate.stringHour }}:{{
                              item.dropOffDate.stringMinute
                            }}
                            <span class="utc-style"
                              >({{ item.dropOffDate.offsetName }})</span
                            >
                          </strong>
                          <span>{{ item.dropOffLocation }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>

    <!-- Start: Modal -->
    <deleteModal @submit="deleteItem" @cancel="cancelDelete" />

    <div class="modal fade" role="dialog" ref="dispatch_modal">
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>{{ dispatchModal.title }}</h4>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- /.modal-header -->
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="col-sm-12">
                <div class="modal-content-body mtz">
                  <div class="row crow">
                    <div class="col-sm-12">
                      <ul
                        v-if="
                          dispatchModal.fetchVehicles &&
                          dispatchModal.fetchDrivers
                        "
                        class="nav nav-tabs nav-justified tabs-mini-form"
                        style="padding-bottom: 15px"
                      >
                        <li
                          v-if="dispatchModal.fetchVehicles"
                          :class="[
                            dispatchModal.activeTab === 'vehicle'
                              ? 'active'
                              : '',
                          ]"
                        >
                          <a
                            href="#dispatch-vehicle-table"
                            data-toggle="tab"
                            @click="dispatchModal.activeTab = 'vehicle'"
                          >
                            <span>Vehicle</span>
                          </a>
                        </li>
                        <li
                          v-if="dispatchModal.fetchDrivers"
                          :class="[
                            dispatchModal.activeTab === 'driver'
                              ? 'active'
                              : '',
                          ]"
                        >
                          <a
                            href="#dispatch-driver-table"
                            data-toggle="tab"
                            @click="dispatchModal.activeTab = 'driver'"
                          >
                            <span>Driver</span>
                          </a>
                        </li>
                      </ul>
                      <div class="tab-content">
                        <div
                          v-if="dispatchModal.fetchVehicles"
                          id="dispatch-vehicle-table"
                          class="tab-pane fade"
                          :class="[
                            dispatchModal.activeTab === 'vehicle'
                              ? 'in active'
                              : '',
                          ]"
                        >
                          <div class="table-modal-detail">
                            <div class="table-responsive table-accordion">
                              <table class="table table-hover mt-5">
                                <thead>
                                  <tr>
                                    <th>Class</th>
                                    <th>Model</th>
                                    <!-- <th>Feature</th> -->
                                    <th>Status</th>
                                    <th class="text-center">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="item in preferredVehicles"
                                    :key="item.vehicleId"
                                  >
                                    <td>{{ item.className }}</td>
                                    <td>
                                      {{ item.plateNumber }} -
                                      {{ item.factoryName }}
                                      {{ item.brandName }}
                                      {{ item.feature.color }} ({{
                                        item.feature.yearManufactured
                                      }})
                                    </td>
                                    <!-- <td>
                                      Pax Seat {{ item.feature.paxCapacity }}, Large Bag. Capacity
                                      {{ item.feature.largeBaggageCapacity }}, Small Bag. Capacity
                                      {{ item.feature.smallBaggageCapacity }}, Transmission
                                      {{ item.feature.transmission }}
                                    </td> -->
                                    <td>{{ humanize(item.event) }}</td>
                                    <td class="text-center">
                                      <div
                                        class="button-action-wrapper"
                                        v-if="
                                          item.isDispatchAllowed &&
                                          isAllowToDispatchVehicle
                                        "
                                      >
                                        <button
                                          class="btn btn-default"
                                          type="button"
                                          @click="openAssignVehicleDialog(item)"
                                        >
                                          <span>Assign</span>
                                        </button>
                                      </div>
                                      <div
                                        class="button-action-wrapper"
                                        v-if="
                                          item.isSelected &&
                                          isAllowToReleaseVehicle
                                        "
                                      >
                                        <button
                                          class="btn btn-default sts-warning"
                                          type="button"
                                          @click="
                                            openReleaseVehicleDialog(item)
                                          "
                                        >
                                          <span>Release</span>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="dispatchModal.fetchDrivers"
                          id="dispatch-driver-table"
                          class="tab-pane fade"
                          :class="[
                            dispatchModal.activeTab === 'driver'
                              ? 'in active'
                              : '',
                          ]"
                        >
                          <div class="table-modal-detail">
                            <div class="table-responsive table-accordion">
                              <table class="table table-hover mt-5">
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Email</th>
                                    <th>Status</th>
                                    <th class="text-center">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="item in preferredDrivers"
                                    :key="item.reservationId"
                                  >
                                    <td>
                                      {{ item.title }}. {{ item.fullName }}
                                    </td>
                                    <td>
                                      (+{{ item.phoneCode }})
                                      {{ item.phoneNumber }}
                                    </td>
                                    <td>{{ item.email }}</td>
                                    <td>{{ humanize(item.event) }}</td>
                                    <td class="text-center">
                                      <div
                                        class="button-action-wrapper"
                                        v-if="
                                          item.isDispatchAllowed &&
                                          isAllowToDispatchDriver
                                        "
                                      >
                                        <button
                                          class="btn btn-default"
                                          type="button"
                                          @click="openAssignDriverDialog(item)"
                                        >
                                          <span>Assign</span>
                                        </button>
                                      </div>
                                      <div
                                        class="button-action-wrapper"
                                        v-if="
                                          item.isSelected &&
                                          isAllowToReleaseDriver
                                        "
                                      >
                                        <button
                                          class="btn btn-default sts-warning"
                                          type="button"
                                          @click="openReleaseDriverDialog(item)"
                                        >
                                          <span>Release</span>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <reservationRepriceComponent></reservationRepriceComponent>

    <div class="modal fade" role="dialog" ref="roreasonmodal">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <div class="col-sm-10">
                <h4>Rescue Operation</h4>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <form action="#" role="form" id="cancelform">
                    <div class="form-group mbz">
                      <div>
                        <strong>Tell us the reason of the rescue.</strong>
                      </div>
                      <div class="btn-group-radio btn-group-newline">
                        <label
                          class="wrap-radio"
                          v-for="(item, index) in reasons"
                          :key="index"
                          @click="onClickReasonCode(item)"
                        >
                          {{ item.text }}
                          <input
                            type="radio"
                            name="reasonCode"
                            :value="item.value"
                            v-model="reasonCode"
                          />
                          <span class="bullet-mark"></span>
                        </label>
                      </div>
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.reasonCode"
                        v-text="validationErrors.reasonCode"
                      ></small>
                    </div>
                    <div class="form-group" v-if="reasonCode === '24'">
                      <textarea
                        class="form-control"
                        rows="4"
                        name="reasonWord"
                        v-model="reasonWord"
                        maxlength="300"
                        required
                      ></textarea>
                      <div
                        class="text-right word-count"
                        v-if="reasonWord && reasonWord !== ''"
                      >
                        {{ reasonWord.length }} from 300 characters
                      </div>
                      <small
                        class="form-text text-danger"
                        v-if="validationErrors.reasonWord"
                        v-text="validationErrors.reasonWord"
                      ></small>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="submit"
                        class="btn btn-primary"
                        @click.prevent="rescueOperation()"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <confirmModal
      :id="'OverrideVehicleConfirmation'"
      :header="'Potential Job Conflict'"
      :content="`This vehicle has another assignment that may overlap this job. Are you sure you wish to proceed?`"
      :cancel-label="'No'"
      :submit-label="'Yes'"
      :color="'confirm-icon'"
      :icon="'ic-warning'"
      @submit="assignVehicle(true)"
    /> -->
    <confirmModal
      :id="'OverrideConfirmation'"
      :header="'Potential Job Conflict'"
      :content="`This driver has another assignment that may overlap this job. Are you sure you wish to proceed?`"
      :cancel-label="'No'"
      :submit-label="'Yes'"
      :color="'confirm-icon'"
      :icon="'ic-warning'"
      @submit="confirmProvider(true)"
    />
    <confirmModal
      :id="'OverrideDriverConfirmation'"
      :header="'Potential Job Conflict'"
      :content="`This driver has another assignment that may overlap this job. Are you sure you wish to proceed?`"
      :cancel-label="'No'"
      :submit-label="'Yes'"
      :color="'confirm-icon'"
      :icon="'ic-warning'"
      @submit="manualDispatchDriver(true)"
    />
    <confirmModal
      :id="'ProviderConfirmation'"
      :header="'Confirm'"
      :content="`Are you sure you want confirm this job?`"
      :cancel-label="'Cancel'"
      :submit-label="'Yes, Confirm'"
      :color="'confirm-icon'"
      :icon="'ic-check'"
      @submit="confirmProvider"
    />
    <confirmModal
      :id="'ProviderDeclineConfirmation'"
      :header="'Decline'"
      :content="`Are you sure you want decline this job?`"
      :cancel-label="'Cancel'"
      :submit-label="'Yes, Decline'"
      :color="'delete-icon'"
      :icon="'ic-close'"
      @submit="declineProvider"
    />
    <confirmModal
      :id="'AssignVehicleConfirmation'"
      :header="'Assign'"
      :content="`Are you sure you want to assign <br/><strong>${selectedVehicle.plateNumber} ${selectedVehicle.factoryName} ${selectedVehicle.brandName}</strong>?`"
      :cancel-label="'Cancel'"
      :submit-label="'Yes, Assign'"
      :color="'confirm-icon'"
      :icon="'ic-check'"
      @submit="assignVehicle"
    />
    <confirmModal
      :id="'ReleaseVehicleConfirmation'"
      :header="'Release'"
      :content="`Are you sure you want release the<br/><strong>${selectedVehicle.plateNumber} ${selectedVehicle.factoryName} ${selectedVehicle.brandName}</strong>?`"
      :cancel-label="'Cancel'"
      :submit-label="'Yes, Release'"
      :color="'delete-icon'"
      :icon="'ic-close'"
      @submit="releaseVehicle"
    />
    <confirmModal
      :id="'AssignDriverConfirmation'"
      :header="'Assign'"
      :content="`Are you sure you want assign to<br/><strong>${selectedDriver.title}. ${selectedDriver.fullName}</strong>?`"
      :cancel-label="'Cancel'"
      :submit-label="'Yes, Assign'"
      :color="'confirm-icon'"
      :icon="'ic-check'"
      @submit="manualDispatchDriver"
    />
    <confirmModal
      :id="'ReleaseDriverConfirmation'"
      :header="'Release'"
      :content="`Are you sure you want release job from<br/><strong>${selectedDriver.title}. ${selectedDriver.fullName}</strong>?`"
      :cancel-label="'Cancel'"
      :submit-label="'Yes, Release'"
      :color="'delete-icon'"
      :icon="'ic-close'"
      @submit="releaseDriver"
    />
    <confirmModal
      :id="'RescueConfirmation'"
      :header="'Rescue'"
      :content="`Are you sure you want to rescue this reservation #<strong>${selectedReservation.code}</strong>?`"
      :cancel-label="'Cancel'"
      :submit-label="'Yes, Rescue'"
      :color="'delete-icon'"
      :icon="'ic-close'"
      @submit="openRescueReasonDialog"
    />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import numeral from "numeral";
import moment from "moment";
import confirmModal from "@/components/shared/ConfirmModal";
import deleteModal from "@/components/shared/DeleteModal";
import reservationRepriceComponent from "@/components/job/providerJob/ProviderReservationReprice";
import inquiryProviderJobService from "@/services/job/providerJob/inquiryProviderJobService.js";

export default {
  components: {
    confirmModal,
    deleteModal,
    reservationRepriceComponent,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToConfirm: function () {
      return this.allPermissions.includes("Confirm");
    },
    isAllowToDecline: function () {
      return this.allPermissions.includes("Decline");
    },
    isAllowToDispatchDriver: function () {
      return this.allPermissions.includes("DispatchDriver");
    },
    isAllowToDispatchVehicle: function () {
      return this.allPermissions.includes("DispatchVehicle");
    },
    isAllowToReleaseDriver: function () {
      return this.allPermissions.includes("ReleaseDriver");
    },
    isAllowToReleaseVehicle: function () {
      return this.allPermissions.includes("ReleaseVehicle");
    },
    isAllowToClose: function () {
      return this.allPermissions.includes("Close");
    },
    isAllowToPublish: function () {
      return this.allPermissions.includes("PublishInvoice");
    },
    isAllowToReprice: function () {
      return this.allPermissions.includes("Repricing");
    },
    time: function () {
      const date = new Date();
      switch (this.period) {
        case "tomorrow":
          date.setDate(date.getDate() + 1);
          break;
        case "next":
          date.setDate(date.getDate() + 2);
          break;
      }
      return moment(date).format("dddd, MMMM DD yyyy");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
    isShowTripLog: function () {
      return this.allPermissions.includes("TripLog");
    },
    pickUpDateExpired() {
      return (utcPickUpDate) => {
        if (this.userType === "TenantUser") {
          return true;
        } else {
          return this.$helper.isNotExpiredDate(utcPickUpDate);
        }
      };
    },
  },
  data() {
    return {
      validationErrors: {
        reasonWord: null,
      },
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
      },
      jobBrowserDateRange: null,
      allPermissions: [],
      defaultPageSize: 0,
      // period: "today",
      period: "today",
      // progress: "open",
      progress: "all",
      items: [
        {
          reservationId: "3b460f30-86c9-4798-bf30-f9af5f2ca9da",
          code: "OPS202201177EAFC",
          className: "MPV",
          reservationDate: {
            year: 2022,
            month: 1,
            day: 17,
            hour: 14,
            minute: 6,
            second: 15,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Mon, 17 Jan 2022",
            stringMonth: "01",
            stringDate: "17",
            stringHour: "14",
            stringMinute: "06",
          },
          originTimezone: "Asia/Jakarta",
          pickUpDate: {
            year: 2022,
            month: 1,
            day: 17,
            hour: 17,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Mon, 17 Jan 2022",
            stringMonth: "01",
            stringDate: "17",
            stringHour: "17",
            stringMinute: "00",
          },
          dropOffDate: {
            year: 2022,
            month: 1,
            day: 17,
            hour: 17,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Mon, 17 Jan 2022",
            stringMonth: "01",
            stringDate: "17",
            stringHour: "17",
            stringMinute: "00",
          },
          utcPickUpDate: "2022-01-17T10:00:00+00:00",
          utcDropOffDate: "2022-01-17T10:00:00+00:00",
          pickUpLocation: "Soekarno-Hatta International Airport",
          isPickUpAirport: false,
          dropOffLocation: "Gambir Station",
          isDropOffAirport: false,
          companyName: "Root ARRANGGE SG",
          companyPhoneCode: "62",
          companyPhoneNumber: "21234567",
          customerName: "Mr. Aussie",
          customerPhoneCode: "62",
          customerPhoneNumber: "85372828",
          providerName: "Dot Car Rentals",
          driverName: null,
          vehicleFactory: null,
          vehicleBrand: null,
          vehiclePlateNo: null,
          lastState: "Provider Assigned",
          serviceType: "AirportTransfer",
          progress: "Under Review",
          isSelfDrive: false,
          hasProvider: true,
          hasDriver: false,
          hasVehicle: false,
          isTodayBooking: false,
          isTodayPickUp: false,
          isTodayDropOff: false,
          searchMode: "Hybrid",
          queueProgress: null,
          minutePickUpOffsetTime: 0,
          flightEstimatedArrivalTimes: null,
          flightConfirmedTimes: null,
          driverStandbyTime: null,
        },
        {
          reservationId: "26a30c17-1399-4134-a813-fd6b4ffe3983",
          code: "OPS2022011748C61",
          className: "MPV",
          reservationDate: {
            year: 2022,
            month: 1,
            day: 17,
            hour: 16,
            minute: 50,
            second: 17,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Mon, 17 Jan 2022",
            stringMonth: "01",
            stringDate: "17",
            stringHour: "16",
            stringMinute: "50",
          },
          originTimezone: "Asia/Jakarta",
          pickUpDate: {
            year: 2022,
            month: 1,
            day: 17,
            hour: 18,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Mon, 17 Jan 2022",
            stringMonth: "01",
            stringDate: "17",
            stringHour: "18",
            stringMinute: "00",
          },
          dropOffDate: {
            year: 2022,
            month: 1,
            day: 17,
            hour: 18,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Mon, 17 Jan 2022",
            stringMonth: "01",
            stringDate: "17",
            stringHour: "18",
            stringMinute: "00",
          },
          utcPickUpDate: "2022-01-17T11:00:00+00:00",
          utcDropOffDate: "2022-01-17T11:00:00+00:00",
          pickUpLocation: "Soekarno-Hatta International Airport",
          isPickUpAirport: false,
          dropOffLocation: "Gambir Station",
          isDropOffAirport: false,
          companyName: "Root ARRANGGE SG",
          companyPhoneCode: "62",
          companyPhoneNumber: "21234567",
          customerName: "Mr. Arata",
          customerPhoneCode: "62",
          customerPhoneNumber: "81380558380",
          providerName: "Dot Car Rentals",
          driverName: null,
          vehicleFactory: null,
          vehicleBrand: null,
          vehiclePlateNo: null,
          lastState: "Provider Assigned",
          serviceType: "AirportTransfer",
          progress: "Under Review",
          isSelfDrive: false,
          hasProvider: true,
          hasDriver: false,
          hasVehicle: false,
          isTodayBooking: false,
          isTodayPickUp: false,
          isTodayDropOff: false,
          searchMode: "Hybrid",
          queueProgress: null,
          minutePickUpOffsetTime: 0,
          flightEstimatedArrivalTimes: null,
          flightConfirmedTimes: null,
          driverStandbyTime: null,
        },
        {
          reservationId: "e15e8440-2088-4629-9b6b-328b0ec6e382",
          code: "OPS20220118B52BF",
          className: "MPV",
          reservationDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 9,
            minute: 43,
            second: 37,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "09",
            stringMinute: "43",
          },
          originTimezone: "Asia/Jakarta",
          pickUpDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 10,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "10",
            stringMinute: "00",
          },
          dropOffDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 10,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "10",
            stringMinute: "00",
          },
          utcPickUpDate: "2022-01-18T03:00:00+00:00",
          utcDropOffDate: "2022-01-18T03:00:00+00:00",
          pickUpLocation: "Soekarno-Hatta International Airport",
          isPickUpAirport: false,
          dropOffLocation: "Gambir Station",
          isDropOffAirport: false,
          companyName: "Root ARRANGGE SG",
          companyPhoneCode: "62",
          companyPhoneNumber: "21234567",
          customerName: "Mr. Arya",
          customerPhoneCode: "62",
          customerPhoneNumber: "81380558380",
          providerName: "(CT Dev) NN Provider Test",
          driverName: null,
          vehicleFactory: null,
          vehicleBrand: null,
          vehiclePlateNo: null,
          lastState: "Provider Assigned",
          serviceType: "AirportTransfer",
          progress: "Under Review",
          isSelfDrive: false,
          hasProvider: true,
          hasDriver: false,
          hasVehicle: false,
          isTodayBooking: false,
          isTodayPickUp: false,
          isTodayDropOff: false,
          searchMode: "Hybrid",
          queueProgress: null,
          minutePickUpOffsetTime: 0,
          flightEstimatedArrivalTimes: null,
          flightConfirmedTimes: null,
          driverStandbyTime: null,
        },
        {
          reservationId: "e1a53878-f09f-4ec4-a790-b12864b482fd",
          code: "OPS202201186C655",
          className: "MPV",
          reservationDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 8,
            minute: 6,
            second: 58,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "08",
            stringMinute: "06",
          },
          originTimezone: "Asia/Jakarta",
          pickUpDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 10,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "10",
            stringMinute: "00",
          },
          dropOffDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 10,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "10",
            stringMinute: "00",
          },
          utcPickUpDate: "2022-01-18T03:00:00+00:00",
          utcDropOffDate: "2022-01-18T03:00:00+00:00",
          pickUpLocation: "Soekarno-Hatta International Airport",
          isPickUpAirport: false,
          dropOffLocation: "Gambir Station",
          isDropOffAirport: false,
          companyName: "Root ARRANGGE SG",
          companyPhoneCode: "62",
          companyPhoneNumber: "21234567",
          customerName: "Mr. Arya",
          customerPhoneCode: "62",
          customerPhoneNumber: "81380558380",
          providerName: "(CT Dev) NN Provider Test",
          driverName: null,
          vehicleFactory: null,
          vehicleBrand: null,
          vehiclePlateNo: null,
          lastState: "Provider Assigned",
          serviceType: "AirportTransfer",
          progress: "Under Review",
          isSelfDrive: false,
          hasProvider: true,
          hasDriver: false,
          hasVehicle: false,
          isTodayBooking: false,
          isTodayPickUp: false,
          isTodayDropOff: false,
          searchMode: "Hybrid",
          queueProgress: null,
          minutePickUpOffsetTime: 0,
          flightEstimatedArrivalTimes: null,
          flightConfirmedTimes: null,
          driverStandbyTime: null,
        },
        {
          reservationId: "3ea1db71-0bbc-4a11-bc53-e30571f3887b",
          code: "OPS20220118CEB5D",
          className: "MPV",
          reservationDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 10,
            minute: 5,
            second: 39,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "10",
            stringMinute: "05",
          },
          originTimezone: "Asia/Jakarta",
          pickUpDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 11,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "11",
            stringMinute: "00",
          },
          dropOffDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 11,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "11",
            stringMinute: "00",
          },
          utcPickUpDate: "2022-01-18T04:00:00+00:00",
          utcDropOffDate: "2022-01-18T04:00:00+00:00",
          pickUpLocation: "Soekarno-Hatta International Airport",
          isPickUpAirport: false,
          dropOffLocation: "Gambir Station",
          isDropOffAirport: false,
          companyName: "Root ARRANGGE SG",
          companyPhoneCode: "62",
          companyPhoneNumber: "21234567",
          customerName: "Mr. Arya",
          customerPhoneCode: "62",
          customerPhoneNumber: "81380558380",
          providerName: "(CT Dev) NN Provider Test",
          driverName: null,
          vehicleFactory: null,
          vehicleBrand: null,
          vehiclePlateNo: null,
          lastState: "Provider Assigned",
          serviceType: "AirportTransfer",
          progress: "Under Review",
          isSelfDrive: false,
          hasProvider: true,
          hasDriver: false,
          hasVehicle: false,
          isTodayBooking: false,
          isTodayPickUp: false,
          isTodayDropOff: false,
          searchMode: "Hybrid",
          queueProgress: null,
          minutePickUpOffsetTime: 0,
          flightEstimatedArrivalTimes: null,
          flightConfirmedTimes: null,
          driverStandbyTime: null,
        },
        {
          reservationId: "b97f2458-647c-4674-a428-bbbb8444834d",
          code: "OPS20220118A5670",
          className: "MPV",
          reservationDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 10,
            minute: 13,
            second: 54,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "10",
            stringMinute: "13",
          },
          originTimezone: "Asia/Jakarta",
          pickUpDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 11,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "11",
            stringMinute: "00",
          },
          dropOffDate: {
            year: 2022,
            month: 1,
            day: 18,
            hour: 11,
            minute: 0,
            second: 0,
            offsetName: "UTC+07:00",
            stringShortMonth: "Jan",
            stringFullDate: "Tue, 18 Jan 2022",
            stringMonth: "01",
            stringDate: "18",
            stringHour: "11",
            stringMinute: "00",
          },
          utcPickUpDate: "2022-01-18T04:00:00+00:00",
          utcDropOffDate: "2022-01-18T04:00:00+00:00",
          pickUpLocation: "Soekarno-Hatta International Airport",
          isPickUpAirport: false,
          dropOffLocation: "Gambir Station",
          isDropOffAirport: false,
          companyName: "Root ARRANGGE SG",
          companyPhoneCode: "62",
          companyPhoneNumber: "21234567",
          customerName: "Mr. Arya",
          customerPhoneCode: "62",
          customerPhoneNumber: "81380558380",
          providerName: "(CT Dev) NN Provider Test",
          driverName: null,
          vehicleFactory: null,
          vehicleBrand: null,
          vehiclePlateNo: null,
          lastState: "Provider Assigned",
          serviceType: "AirportTransfer",
          progress: "Under Review",
          isSelfDrive: false,
          hasProvider: true,
          hasDriver: false,
          hasVehicle: false,
          isTodayBooking: false,
          isTodayPickUp: false,
          isTodayDropOff: false,
          searchMode: "Hybrid",
          queueProgress: null,
          minutePickUpOffsetTime: 0,
          flightEstimatedArrivalTimes: null,
          flightConfirmedTimes: null,
          driverStandbyTime: null,
        },
      ],
      reasons: [],
      reasonWord: null,
      reasonCode: null,
      totalAllJobs: 0,
      totalJobsOpen: 0,
      totalJobsRun: 0,
      totalJobsUnderReview: 0,
      totalJobsDone: 0,
      totalJobsClose: 0,
      totalJobsAborted: 0,
      totalJobsRescued: 0,
      preferredDrivers: [],
      preferredVehicles: [],
      reservationId: null,
      selectedProvider: {},
      selectedVehicle: {},
      selectedDriver: {},
      selectedReservation: {},
      selectedJobItem: {},
      moneyFormat: null,
      transactionMaster: {
        booker: {},
        serviceType: "",
        code: "",
        reservationDate: {},
        passengers: [],
        pickUpDate: {},
        pickUpLocation: {},
        dropOffDate: {},
        dropOffLocation: {},
        className: "",
        paymentStatus: "",
        currencyCode: "",
        grandTotal: "",
        histories: [],
        fareComponents: [],
        fareComponentsSelling: [],
        fareComponentsBuying: [],
      },
      dispatchModal: {
        title: "Dispatch",
        activeTab: "vehicle",
        fetchVehicles: false,
        fetchDrivers: false,
      },
      isLoading: false,
      msg: "Please wait",
      userType: "Unspecified",
    };
  },
  async created() {
    this.$helper.scrollTop();
    await this.getUserType();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      publicSettings,
      "PageSize",
      25
    );
    this.defaultPageSize = this.table.pageSize;

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      this.reasons = [
        { value: "19", text: "Flight Delay" }, // RescueOperationFlightDelay
        { value: "20", text: "Pax No Show " }, // RescueOperationPaxNoShow
        { value: "21", text: "Company ReAssign " }, // RescueOperationCompanyReAssign
        { value: "22", text: "Traffic Delay " }, // RescueOperationTrafficDelay
        // { value: "23", text: "Vehicle Broke Or Accident" }, // RescueOperationVehicleBrokeOrAccident
        // { value: "24", text: "OtherEmergencies" }, // RescueOperationOtherEmergencies
      ];

      await Promise.all([
        this.countAll(),
        this.getAll(this.period, this.progress),
      ]);
    }
  },
  mounted() {
    $(".modal").on("hidden.bs.modal", function (e) {
      if ($(".modal").hasClass("in")) {
        $("body").addClass("modal-open");
      }
    });
  },
  updated() {
    this.$eventBus.$on(
      "openProviderJobBrowserDeleteModal",
      this.openProviderJobBrowserDeleteModal
    );
    this.$eventBus.$on("reloadData", this.reloadData);
    this.$helper.collapseMenu("job");
    this.$helper.setNavigationClass("provider-job-browser-link");
    $("#jobBrowserDateRange-input").addClass("borderless-jobBrowserDateRange");
  },
  beforeDestroy() {
    this.$eventBus.$off("openProviderJobBrowserDeleteModal");
    this.$eventBus.$off("reloadData");
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll(this.period, this.progress);
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll(self.period, self.progress);
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll(this.period, this.progress);
    },
    isAirportTransfer(serviceType) {
      return serviceType.toLowerCase() === "airporttransfer";
    },
    async changeProgress(progress) {
      this.table.keyword = "";
      this.table.pageNumber = 1;
      this.table.pageSize = this.defaultPageSize;
      this.progress = progress;
      await this.getAll(this.period, this.progress);
    },
    async changePeriods(period) {
      this.period = period;
      await Promise.all([
        this.countAll(),
        this.getAll(period, this.progress, true),
      ]);
    },
    async getAll(period, progress, clear = false) {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        if (clear) this.table.pageNumber = 1;
        this.isLoading = true;
        this.items = [];
        this.period = period;
        this.progress = progress;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        filter += `&data=${this.progress};0;${this.convertPeriod()}`;
        const response = await inquiryProviderJobService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
        if (response.data.length > 0) {
          this.moneyFormat = response.data[0].moneyFormat;
        }
        this.progress = progress;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async countAll() {
      try {
        const response = await inquiryProviderJobService.countAll(
          this.convertPeriod(),
          0
        );
        this.totalAllJobs = response.data.totalAllJobs;
        this.totalJobsOpen = response.data.totalJobsOpen;
        this.totalJobsRun = response.data.totalJobsRun;
        this.totalJobsUnderReview = response.data.totalJobsUnderReview;
        this.totalJobsDone = response.data.totalJobsDone;
        this.totalJobsClose = response.data.totalJobsClose;
        this.totalJobsAborted = response.data.totalJobsAborted;
        this.totalJobsRescued = response.data.totalJobsRescued;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async getPreferredDrivers(item) {
      try {
        this.preferredDrivers =
          await inquiryProviderJobService.getPreferredDrivers(
            item.reservationId
          );
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async getPreferredVehicles(item) {
      try {
        this.preferredVehicles =
          await inquiryProviderJobService.getPreferredVehicles(
            item.reservationId
          );
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async getUserType() {
      const profile = await this.$store.dispatch("user/getProfile");
      this.userType = profile.userType;
    },
    openProviderConfirmationDialog(item) {
      this.selectedProvider = item;
      $("#ProviderConfirmation").modal({ backdrop: "static", keyboard: false });
    },
    openProviderDeclineDialog(item) {
      this.selectedProvider = item;
      $("#ProviderDeclineConfirmation").modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    openAssignVehicleDialog(item) {
      this.selectedVehicle = item;
      $("#AssignVehicleConfirmation").modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    openReleaseVehicleDialog(item) {
      this.selectedVehicle = item;
      $("#ReleaseVehicleConfirmation").modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    openAssignDriverDialog(item) {
      this.selectedDriver = item;
      $("#AssignDriverConfirmation").modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    openReleaseDriverDialog(item) {
      this.selectedDriver = item;
      $("#ReleaseDriverConfirmation").modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    async openDispatchModal(item, fetchVehicles, fetchDrivers) {
      this.selectedJobItem = item;
      this.dispatchModal.fetchVehicles = fetchVehicles;
      this.dispatchModal.fetchDrivers = fetchDrivers;

      if (fetchVehicles === true && fetchDrivers === true) {
        this.dispatchModal.title = "Dispatch";
        this.dispatchModal.activeTab = "vehicle";
      } else {
        this.dispatchModal.title =
          fetchDrivers === true ? "Dispatch Driver" : "Dispatch Vehicle";
        this.dispatchModal.activeTab =
          fetchDrivers === true ? "driver" : "vehicle";
      }

      let tasks = [];

      if (fetchVehicles) {
        tasks.push(this.getPreferredVehicles(item));
      }
      if (fetchDrivers) {
        tasks.push(this.getPreferredDrivers(item));
      }

      if (tasks.length > 0) {
        this.isLoading = true;
        this.reservationId = item.reservationId;

        await Promise.all(tasks);

        this.isLoading = false;

        $(this.$refs.dispatch_modal).modal({
          backdrop: "static",
          keyboard: false,
        });
      }
    },
    async confirmProvider(overrideTimingBlock = false) {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.confirmProvider({
          reservationId: this.selectedProvider.reservationId,
          providerId: this.selectedProvider.providerId,
          overrideTimingBlock: overrideTimingBlock,
        });

        await Promise.all([
          this.countAll(),
          this.getAll(this.period, this.progress),
        ]);

        $(this.$refs.provider_driverpreferrences_modal).modal("hide");
        this.$notification.success("Successfully confirmed.", {
          title: "Success",
        });
      } catch (error) {
        if (
          this.userType === "TenantUser" &&
          error.errors[0].includes("JTB001|")
        ) {
          $("#OverrideConfirmation").modal({
            backdrop: "static",
            keyboard: false,
          });
        } else {
          if (error.errors) {
            for (let index = 0; index < error.errors.length; index++) {
              this.$notification.error(error.errors[index], { title: "Error" });
            }
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async declineProvider() {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.declineProvider({
          reservationId: this.selectedProvider.reservationId,
          providerId: this.selectedProvider.providerId,
        });

        await Promise.all([
          this.countAll(),
          this.getAll(this.period, this.progress),
        ]);

        $(this.$refs.provider_driverpreferrences_modal).modal("hide");
        this.$notification.success("Successfully declined.", {
          title: "Success",
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async assignVehicle() {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.assignVehicle({
          reservationId: this.reservationId,
          vehicleId: this.selectedVehicle.vehicleId,
        });

        await Promise.all([
          this.getPreferredVehicles({ reservationId: this.reservationId }),
          this.countAll(),
          this.getAll(this.period, this.progress),
        ]);

        $(this.$refs.provider_vehiclepreferrences_modal).modal("hide");
        this.$notification.success("Successfully assigned.", {
          title: "Success",
          position: "topCenter",
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            let errMsg = error.errors[index];
            errMsg = errMsg.replace("JTB001|", "").trim();
            this.$notification.error(errMsg, { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async releaseVehicle() {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.releaseVehicle({
          reservationId: this.reservationId,
          vehicleId: this.selectedVehicle.vehicleId,
        });

        await Promise.all([
          this.getPreferredVehicles({ reservationId: this.reservationId }),
          this.countAll(),
          this.getAll(this.period, this.progress),
        ]);

        $(this.$refs.provider_vehiclepreferrences_modal).modal("hide");
        this.$notification.success("Successfully released.", {
          title: "Success",
          position: "topCenter",
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], {
              title: "Error",
              position: "topCenter",
            });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async manualDispatchDriver(overrideTimingBlock = false) {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.manualDispatchDriver({
          reservationId: this.reservationId,
          driverId: this.selectedDriver.driverId,
          overrideTimingBlock: overrideTimingBlock,
        });

        await Promise.all([
          this.getPreferredDrivers({ reservationId: this.reservationId }),
          this.countAll(),
          this.getAll(this.period, this.progress),
        ]);

        $(this.$refs.provider_driverpreferrences_modal).modal("hide");
        this.$notification.success("Successfully dispatched.", {
          title: "Success",
          position: "topCenter",
        });
      } catch (error) {
        if (
          this.userType === "TenantUser" &&
          error.errors[0].includes("JTB001|")
        ) {
          $("#OverrideDriverConfirmation").modal({
            backdrop: "static",
            keyboard: false,
          });
        } else {
          if (error.errors) {
            for (let index = 0; index < error.errors.length; index++) {
              this.$notification.error(error.errors[index], { title: "Error" });
            }
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async releaseDriver() {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.releaseDriver({
          reservationId: this.reservationId,
          driverId: this.selectedDriver.driverId,
        });

        await Promise.all([
          this.getPreferredDrivers({ reservationId: this.reservationId }),
          this.countAll(),
          this.getAll(this.period, this.progress),
        ]);

        $(this.$refs.provider_driverpreferrences_modal).modal("hide");
        this.$notification.success("Successfully released.", {
          title: "Success",
          position: "topCenter",
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], {
              title: "Error",
              position: "topCenter",
            });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    openProviderJobBrowserDeleteModal(option, id) {
      this.deleteOption = option;
      this.deleteId = id;
      $("#deletemodal").modal({ backdrop: "static", keyboard: false });
    },
    cancelDelete() {
      switch (this.deleteOption) {
        case "inquiryReservationFareComponent":
          // publish message
          this.$eventBus.$emit("openModalReservationReprice", this.deleteId);
          break;
      }
      this.deleteId = null;
      this.deleteOption = null;
      $("#deletemodal").modal("hide");
    },
    async deleteItem() {
      try {
        this.isLoading = true;
        switch (this.deleteOption) {
          case "inquiryReservationFareComponent":
            // publish message
            this.$eventBus.$emit("deleteFareComponent", this.deleteId);
            break;
        }
        this.deleteId = null;
        this.deleteOption = null;
        $("#deletemodal").modal("hide");
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    openRescueDialog(item) {
      this.selectedProvider = Object.assign({}, item);
      $("#RescueConfirmation").modal({ backdrop: "static", keyboard: false });
    },
    onClickReasonCode(item) {
      this.reasonCode = item.value;
      this.reasonWord = item.text;
      if (this.reasonCode === "24") {
        this.reasonWord = null;
      }
    },
    openRescueReasonDialog() {
      this.validationErrors.reasonWord = null;
      this.onClickReasonCode(this.reasons[0]);
      $(this.$refs.roreasonmodal).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    async rescueOperation() {
      try {
        this.isLoading = true;
        await inquiryProviderJobService.rescueReservation({
          reason: this.reasonCode,
          reservationId: this.selectedProvider.reservationId,
        });

        await Promise.all([
          this.countAll(),
          this.getAll(this.period, this.progress),
        ]);

        $(this.$refs.roreasonmodal).modal("hide");
        this.$notification.success("Successfully rescued.", {
          title: "Success",
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    getReferredHistory(item) {
      if (item.driver !== null) {
        return "Driver: " + item.driver.title + ". " + item.driver.fullName;
      } else if (item.provider !== null) {
        return "Provider: " + item.provider.name;
      } else if (item.vehicle !== null) {
        return (
          "Vehicle: " +
          item.vehicle.factoryName +
          " " +
          item.vehicle.brandName +
          " (" +
          item.vehicle.plateNumber +
          ")"
        );
      }
      return "";
    },
    viewReservationReprice(item) {
      // publish message
      this.$eventBus.$emit("initializeReservationReprice", item);
    },
    convertPeriod() {
      let result = "";
      const date = new Date();
      switch (this.period.toLowerCase()) {
        case "all":
          this.jobBrowserDateRange = null;
          result = "all";
          break;
        case "today":
          this.jobBrowserDateRange = null;
          result = `today_${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()}`;
          break;
        case "tomorrow":
          this.jobBrowserDateRange = null;
          date.setDate(date.getDate() + 1);
          result = `tomorrow_${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()}`;
          break;
        case "next":
          this.jobBrowserDateRange = null;
          date.setDate(date.getDate() + 2);
          result = `next_${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()}`;
          break;
        case "range":
          result = `range_${this.jobBrowserDateRange.start}_${this.jobBrowserDateRange.end}`;
          break;
      }
      return result;
    },
    printMoney(value) {
      return this.moneyFormat
        ? numeral(value).format(this.moneyFormat.decimalFormat)
        : value;
    },
    async closeReservation(item) {
      try {
        this.isLoading = true;
        var request = {
          reservationId: item.reservationId,
          providerId: item.providerId,
        };
        var response = await inquiryProviderJobService.closeReservation(
          request
        );
        await this.reloadData();
        this.countAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async reloadData() {
      await this.getAll(this.period, this.progress);
    },
    canReprice(item) {
      if (item.progress != "Done") {
        return false;
      }
      return true;
    },
    canPublishInvoice(item) {
      if (item.progress != "Done") {
        return false;
      }
      if (item.isUnderPaid) {
        return false;
      }
      return true;
    },
    canClose(item) {
      if (item.progress != "Done") {
        return false;
      }
      if (item.lastState != "Invoiced") {
        return false;
      }
      return true;
    },
    canRescue(item) {
      if (item.progress != "Run") {
        return false;
      }
      if (
        item.lastState == "Driver Pick Up" ||
        item.lastState == "Driver Arrived" ||
        item.lastState == "Passenger On Board" ||
        item.lastState == "Passenger On Trip" ||
        item.lastState == "Passenger Extra Stop" ||
        item.lastState == "Passenger Re Route"
      ) {
        return true;
      }
      return false;
    },
    shortenString(item, textToBeReplaced) {
      return item.replace(textToBeReplaced, "");
    },
    getLastState(item) {
      // if((item.lastState === "Driver Assigned" || item.lastState === "Vehicle Assigned") && item.hasDriver && item.hasVehicle){
      if (item.hasDriver && item.hasVehicle) {
        return "Driver & Vehicle Assigned";
      } else {
        return item.lastState;
      }
    },
    showPicker() {
      $(".tabs-inquiry").removeClass("sticky");
    },
    hidePicker() {
      $(".tabs-inquiry").addClass("sticky");
    },
    async searchRange() {
      if (
        !this.jobBrowserDateRange.start ||
        this.jobBrowserDateRange.start === "" ||
        !this.jobBrowserDateRange.end ||
        this.jobBrowserDateRange.end === ""
      ) {
        alert("Please select a date range.");
        return;
      }
      this.hidePicker();
      await this.changePeriods("range");
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
    inactiveVehicle(item) {
      return (
        item.progress &&
        ["open", "run", "rescueoperation"].includes(
          item.progress.toLowerCase()
        ) &&
        item.hasVehicle &&
        !item.isActiveVehicle
      );
    },
    inactiveDriver(item) {
      return (
        item.progress &&
        ["open", "run", "rescueoperation"].includes(
          item.progress.toLowerCase()
        ) &&
        item.hasDriver &&
        !item.isActiveDriver
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/job/providerJob/ProviderJob.vue